import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Langs from "../../../../app/lang/langs";
import MobileProgressView from "./MobileProgressView";

/**
 * MobileProgressTab - Mobile-first version of ProgressTab.
 * Renders ProgressView in a scrollable container with a sticky bottom "Next" button in edit mode.
 */
export default function MobileProgressTab({
    isMobile,
    mode,
    setActiveIndex,
}) {
    return (
        <Fade in timeout={350}>
            <Box
                sx={{
                    mt: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                {/* Scrollable content area */}
                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                        height: "calc(100vh - 160px)",
                        px: 2,
                        pt: 2,
                    }}
                >
                    <MobileProgressView />
                </Box>

                {/* Sticky bottom navigation */}
                {mode === "edit" && (
                    <Box
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            px: 2.5,
                            py: 2,
                            pb: "calc(env(safe-area-inset-bottom, 0px) + 24px)",
                            background: "linear-gradient(to top, rgba(255,255,255,0.92) 50%, rgba(255,255,255,0.78) 100%)",
                            backdropFilter: "blur(18px) saturate(1.6)",
                            WebkitBackdropFilter: "blur(18px) saturate(1.6)",
                            borderTop: "1px solid rgba(255, 144, 21, 0.15)",
                            boxShadow: "0 -4px 24px rgba(255, 144, 21, 0.06), 0 -1px 6px rgba(0, 0, 0, 0.04)",
                            zIndex: 10,
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => setActiveIndex(0)}
                            sx={{
                                borderRadius: "14px",
                                textTransform: "none",
                                minHeight: 50,
                                fontWeight: 700,
                                fontSize: "0.95rem",
                                letterSpacing: "-0.01em",
                                background: "linear-gradient(135deg, #FF9015 0%, #FFA940 100%)",
                                backgroundColor: "#FF9015",
                                color: "#fff",
                                border: "none",
                                boxShadow: "0 4px 16px rgba(255, 144, 21, 0.40), 0 8px 32px rgba(255, 144, 21, 0.20), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                                transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
                                "&:hover": {
                                    background: "linear-gradient(135deg, #FF9015 0%, #FFB74D 100%)",
                                    backgroundColor: "#FF9015",
                                    boxShadow: "0 6px 24px rgba(255, 144, 21, 0.50), 0 12px 40px rgba(255, 144, 21, 0.25)",
                                    transform: "translateY(-2px)",
                                },
                                "&:active": {
                                    transform: "scale(0.98)",
                                    boxShadow: "0 2px 10px rgba(255, 144, 21, 0.35)",
                                },
                            }}
                        >
                            <Langs str="Next" />
                        </Button>
                    </Box>
                )}
            </Box>
        </Fade>
    );
}
